import React from 'react';
import { ReactComponent as Chevron } from 'theme/assets/images/chevron-right.svg';
import { communicationUtilities } from '@incentivegames/ig-frontend-common/lib/utilities/communicationUtilities';
import { RedirectType } from '@incentivegames/ig-types/lib/enums/communication/redirectType';
import { useTranslation } from 'react-i18next';
import Config from 'theme/config';

import './UpsellBanner.scss';

const UpsellBanner = () => {
  const { t } = useTranslation();

  return (
    <div className="upsell-banner" onClick={() => communicationUtilities.sendPostMessage.redirect(RedirectType.dreamteam, Config.settings.upsellBannerURL)}>
      <div className="upsell-banner__title">{t('upsell-banner-title')}</div>
      <div className="upsell-banner__price-boosts">
        <div className="upsell-banner__price-boosts__text">{t('upsell-banner-price-boost')}</div>
        <Chevron className="upsell-banner__price-boosts__icon" />
      </div>
    </div>
  );
};

export default UpsellBanner;
